import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { GuideInfo } from '../models/guide-info';
import { PhasesResponse } from '../models/phase';

@Injectable({
  providedIn: 'root',
})
export class GettingStartedService {
  private http = inject(HttpClient);

  private readonly api = '/api/maz/v1';

  getGuideInfo(): Observable<GuideInfo> {
    return this.http.get<GuideInfo>(`${this.api}/common_copy`);
  }

  getPhases(): Observable<PhasesResponse> {
    return this.http.get<PhasesResponse>(`${this.api}/phases`);
  }

  notifyResourceLinkOpened(url: string): Observable<void> {
    return this.http.post<void>(`${this.api}/resource_view`, { url });
  }
}
